let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3e3dr")).then(() => parcelRequire('4LBXw'));